import React from "react";

export default function GanttTodayLine(props) {

  var {
    timelineStart,
    weekWidth,
    height
  } = props;

  function daysBetween(a, b) {
    var ms = b.getTime() - a.getTime();
    return Math.round(ms / (1000 * 60 * 60 * 24));
  }

  var today = new Date();
  var days = daysBetween(timelineStart, today);
  var weeks = days / 7;
  var left = weeks * weekWidth;

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: left,
        height: height,
        width: "2px",
        background: "#d32f2f",
        zIndex: 10,
        opacity: 0.9
      }}
      title="Today"
    />
  );
}
